<template>
  <pt-detection-corpus-detail class="pt-detection-corpus-detail__page" :id="id" :value="value"></pt-detection-corpus-detail>
</template>

<script>
import PtDetectionCorpusDetail from 'cps/gene-product/pt-detection-corpus-detail/withData'
export default {
  name: 'pt-detection-corpus-detail__view',
  components: {
    'pt-detection-corpus-detail': PtDetectionCorpusDetail
  },
  props: {
    // 路由参数 - 产品id
    id: {
      type: String,
      required: true
    },
    // 路由参数 - 产品数据，父组件可以直接传入整个产品对象绑定到详情页，也可以不传。
    value: {
      type: Object,
      default: null
    }
  }
}
</script>
